import React from "react"
import styled from "styled-components"
import { HeadingTwo, Paragraph } from "buoy-core"
import Button from "../Button"
import responsive from "../../common/responsive"
import { colors, fontWeight, fontSize } from "buoy-theme"
import HandShake from "../../assets/images/handshake.svg"
import { generatePageUrl } from "../../common/utils"

const Container = styled.div`
  background: ${colors.landingBackground};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${responsive("width", "100vw", "100vw", "100vw", "100vw")};
  ${responsive(
    "padding",
    "46px 0 56px",
    "46px 0 56px",
    "38px 0 48px",
    "38px 20px 48px"
  )};
  margin: 0 -20px;
`

const Body = styled(Paragraph).attrs({
  small: true,
  center: true,
  margin: "0 auto",
})`
  ${responsive("max-width", "520px", "520px", "350px", "340px")};
  ${responsive("margin-bottom", "20px", "20px", "20px", "20px")};
`

const Heading = styled(HeadingTwo)`
  ${fontSize("h3")};
  margin-bottom: 12px;
`

const HandShakeIcon = styled.img`
  margin-bottom: 10px;
  height: 64px;
`

const Partner = ({ headline, body, button }) => (
  <Container>
    <HandShakeIcon src={HandShake} alt="Partner with Buoy" />
    <Heading>{headline}</Heading>
    <Body>{body}</Body>
    <Button
      ghost
      backgroundColor="transparent"
      color="landingBlue"
      href={generatePageUrl(button.link)}
    >
      {button.text}
    </Button>
  </Container>
)

export { Partner as default }



// WEBPACK FOOTER //
// ./src/components/Partner/index.js